var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 8H15.3334V9.33333H14.0001V8ZM14.0001 5.33333H15.3334V6.66667H14.0001V5.33333ZM15.3334 10.6667H14.0001V12C14.6667 12 15.3334 11.3333 15.3334 10.6667ZM8.66675 0H10.0001V1.33333H8.66675V0ZM14.0001 2.66667H15.3334V4H14.0001V2.66667ZM14.0001 0V1.33333H15.3334C15.3334 0.666667 14.6667 0 14.0001 0ZM0.666748 2.66667H2.00008V4H0.666748V2.66667ZM11.3334 0H12.6667V1.33333H11.3334V0ZM11.3334 10.6667H12.6667V12H11.3334V10.6667ZM2.00008 0C1.33341 0 0.666748 0.666667 0.666748 1.33333H2.00008V0ZM6.00008 0H7.33341V1.33333H6.00008V0ZM3.33341 0H4.66675V1.33333H3.33341V0ZM0.666748 5.33333V10.6667C0.666748 11.4 1.26675 12 2.00008 12H10.0001V5.33333H0.666748ZM2.00008 10.6667L3.66675 8.52667L4.86008 9.96L6.52675 7.81333L8.66675 10.6667H2.00008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/size-icon.1f66072726f9032ccb7a973d3f6f5e67.svg";
export { ForwardRef as ReactComponent };